import { Skeleton } from '@components'
import Column from '@components/column'
import { GenreImageWrapper } from '../style'

const GenresLoader = () => {
  return (
    <>
      <Column
        alignItems="center"
        styleColumn={`
              text-align: center; 
              max-width: 120px; 
              @media (max-width: 640px) { max-width: 70px; }
              cursor: pointer; 
              flex-shrink: 0;
              transition: transform 0.3s ease;

            `}
        rowGap={10}
      >
        <GenreImageWrapper>
          <Skeleton width="100%" height={'100%'} radius={50} />
        </GenreImageWrapper>
        <Skeleton width={'80%'} height={10} radius={50} />
      </Column>
    </>
  )
}

export default GenresLoader
